import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { ActivateIcon, AlertIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';
import { recentAlteration, voucherFailure, voucherSuccess } from 'store/actions/orderActions';

class SendMailModal extends React.Component {
    constructor(props) {
        super(props);

        this.sendVoucherRequest = this.sendVoucherRequest.bind(this);
    }

    sendVoucherRequest = () => {
        const { id } = this.props;

        const url = `${ config.getApiBaseUrl() }/bookings/${ id }/voucher/send`;

        return apiClient.create(url).then(() => {
            const message = 'resources.orders.voucher.send.success';

            this.props.voucherSuccess(message);
        }, (error) => {
            this.props.voucherFailure(error);
        });
    }

    handleDialogSubmit = () => {
        this.sendVoucherRequest();

        this.handleDialogClose();
    };

    handleDialogClose = () => {
        this.props.recentAlterationOff(this.props.id, false);
    }

    render() {
        const { translate, recentAlteration } = this.props;

        const actions = [
            <RaisedButton
                icon={ <AlertIcon /> }
                key='cancel'
                keyboardFocused={ true }
                label={ translate('actions.cancel') }
                onTouchTap={ this.handleDialogClose }
                style={ { marginRight: '20px' } }
            />,
            <RaisedButton
                icon={ <ActivateIcon /> }
                key='submit'
                label={ translate('actions.ok') }
                onTouchTap={ () => {
                    return this.handleDialogSubmit();
                } }
                primary
            />,
        ];

        return (
            <Dialog
                actions={ actions }
                actionsContainerStyle={ { padding: '0 24px 24px' } }
                contentStyle={ { maxWidth: '600px' } }
                modal={ false }
                overlayStyle={ {
                    backgroundColor: 'rgba(237, 236, 236, 0.6)',
                } }
                onRequestClose={ this.handleDialogClose }
                open={ recentAlteration }
                title={ translate('resources.orders.voucher.send.title') }
            >
                { translate('resources.orders.voucher.after_alteration.description') }
            </Dialog>
        );
    }
}

SendMailModal.propTypes = {
    id: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
    recentAlterationOff: PropTypes.func.isRequired,
    recentAlteration: PropTypes.bool.isRequired,
    voucherFailure: PropTypes.func.isRequired,
    voucherSuccess: PropTypes.func.isRequired,
};

export default connect(
    (state, props) => {
        const recentAlteration = utils.get(state.orders, `data.${ props.id }.recentAlteration`, false);

        return {
            recentAlteration: recentAlteration,
        };
    },
    {
        recentAlterationOff: recentAlteration,
        voucherFailure: voucherFailure,
        voucherSuccess: voucherSuccess,
    },
)(translate(SendMailModal));



// WEBPACK FOOTER //
// ./src/components/modals/SendMailModal.js